var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5182 27.3321L19.1797 29.0067L27.9984 20.1185L26.3369 18.4439L17.5182 27.3321ZM25.5701 17.671L23.9086 15.9964L15.0898 24.8847L16.8792 26.6881L25.5701 17.671ZM28.2541 11.6167L32.4717 15.8676C33.2386 16.6405 33.1107 17.7998 32.4717 18.4439L19.8187 31.1966L11 33L12.7893 24.1118C20.7134 15.9964 24.931 11.7455 25.4423 11.3591C26.2091 10.8438 27.4872 10.8438 28.2541 11.6167Z",
    fill: "#FA9418"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditActionIcon);
export default __webpack_public_path__ + "static/media/editActionIcon.f9f79031a97fd27f4ffe8c0709131b6c.svg";
export { ForwardRef as ReactComponent };